import { ref } from 'vue'

/** Управление загрузкой, превью и удалением иконки группы */
export function useGroupIcon() {
  const iconPreview = ref<string | null>(null)
  const currentIconUrl = ref<string | null>(null)
  const refIconInput = ref<HTMLInputElement>()
  const formIcon = ref<File | null>(null)
  /** true — пользователь явно нажал «Удалить» (не путать с «файл не выбран»). */
  const iconRemoved = ref(false)

  function openUploadDialog() {
    refIconInput.value?.click()
  }

  function handleUpload(event: Event) {
    const input = event.target as HTMLInputElement
    const file = input.files?.[0]
    if (!file) return

    formIcon.value = file
    iconRemoved.value = false
    const reader = new FileReader()
    reader.onload = e => {
      iconPreview.value = e.target?.result as string
    }
    reader.readAsDataURL(file)
  }

  function handleDelete() {
    formIcon.value = null
    iconRemoved.value = true
    iconPreview.value = null
    if (refIconInput.value) {
      refIconInput.value.value = ''
    }
  }

  function loadFromChat(iconUrl: string | null) {
    currentIconUrl.value = iconUrl
    iconPreview.value = iconUrl
    formIcon.value = null
    iconRemoved.value = false
  }

  function reset() {
    formIcon.value = null
    iconPreview.value = null
    currentIconUrl.value = null
    iconRemoved.value = false
    if (refIconInput.value) {
      refIconInput.value.value = ''
    }
  }

  /** undefined — не трогать аватар; File — загрузить; null — удалить. */
  function getIconUpdatePayload(): File | null | undefined {
    if (formIcon.value instanceof File) {
      return formIcon.value
    }
    if (iconRemoved.value) {
      return null
    }
    return undefined
  }

  return {
    iconPreview,
    currentIconUrl,
    refIconInput,
    formIcon,
    iconRemoved,
    openUploadDialog,
    handleUpload,
    handleDelete,
    loadFromChat,
    reset,
    getIconUpdatePayload,
  }
}
